namespace Matrix.Rebalancer {
    export class HoldingClassWeightColumns {
        static columnsKey = 'Rebalancer.HoldingClassWeight';
    }
}
